import { render, staticRenderFns } from "./order-reciept.vue?vue&type=template&id=0007f4c8&"
import script from "./order-reciept.vue?vue&type=script&lang=tsx&"
export * from "./order-reciept.vue?vue&type=script&lang=tsx&"
import style0 from "./order-reciept.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports